const $$splitComponentImporter = () => import('/home/runner/work/zngly-corporate/zngly-corporate/wp-content/themes/zngly-corporate/frontend/src/routes/auth/oauth-callback.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { requireLoggedInUser } from '@/Router';
import { msRegisterMutation } from '@/graphql/mutations/Integration.mutation';
import { type AccountInfo, type AuthenticationResult, EventType, type PublicClientApplication } from '@azure/msal-browser';
import { createFileRoute } from '@tanstack/react-router';
import { toast } from 'react-toastify';
let msalInstance: PublicClientApplication | null = null;
const onAccountChanged = [] as Array<() => void>;
export const addMsalCallback = (callback: () => void) => {
  onAccountChanged.push(callback);
};
export const getMsalInstance = async () => {
  if (msalInstance) return msalInstance;
  const MyPublicClientApplication = await import('@azure/msal-browser').then(mod => mod.PublicClientApplication);
  msalInstance = new MyPublicClientApplication({
    auth: {
      clientId: 'a3f69ae9-7d8a-48ce-b9e2-fbc39a5814cb',
      // This is the ONLY mandatory field that you need to supply.
      authority: 'https://login.microsoftonline.com/organizations',
      redirectUri: 'https://internal.zngly.com'
      // redirectUri: 'http://localhost:5173',
    },
    cache: {
      cacheLocation: 'sessionStorage',
      // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
      storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
    }
  });

  // Leave comment for future testing
  // Enable logging for debugging
  // msalInstance.setLogger(
  //   new Logger({
  //     loggerCallback: (level, message) => {
  //       if (isLocalhost()) {
  //         console.info('msal log', level, message);
  //       }
  //     },
  //   })
  // );

  if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
    // Default to using the first account if no account is active on page load
    // Account selection logic is app dependent. Adjust as needed for different use cases.
    msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
  }

  // Listen for sign-in event and set active account
  msalInstance.addEventCallback(event => {
    if ((event.eventType === EventType.LOGIN_SUCCESS || event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) && (event.payload as AuthenticationResult)?.account) {
      const account = (event.payload as AuthenticationResult)?.account as AccountInfo;
      msRegisterMutation({
        input: {
          tenantId: account.tenantId
        }
      }, {
        onCompleted: (data, errors) => {
          if (errors || !data?.msAuthenticateTenant?.success) {
            toast.error('Failed to register Zngly to your Microsoft account. Please contact support.');
            return;
          }
          toast.success('Zngly is now connected to your Microsoft account');
          msalInstance?.setActiveAccount?.(account);
          for (const func of onAccountChanged) {
            func();
          }
        }
      });
    }
    if (event.eventType === EventType.LOGOUT_SUCCESS) {
      for (const func of onAccountChanged) {
        func();
      }
    }
  });
  return msalInstance;
};
export const Route = createFileRoute('/auth/oauth-callback')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr),
  beforeLoad() {
    requireLoggedInUser({
      to: '/auth/login'
    });
  }
});